var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.125 9.625L11.375 6.25L6.125 2.875V9.625ZM5 13.75V12.25H2C1.5875 12.25 1.23438 12.1031 0.940625 11.8094C0.646875 11.5156 0.5 11.1625 0.5 10.75V1.75C0.5 1.3375 0.646875 0.984375 0.940625 0.690625C1.23438 0.396875 1.5875 0.25 2 0.25H14C14.4125 0.25 14.7656 0.396875 15.0594 0.690625C15.3531 0.984375 15.5 1.3375 15.5 1.75V10.75C15.5 11.1625 15.3531 11.5156 15.0594 11.8094C14.7656 12.1031 14.4125 12.25 14 12.25H11V13.75H5Z",
    fill: "#00538A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/VideoIcon.fe2a26df9942ce960cde6943a4cadb89.svg";
export { ForwardRef as ReactComponent };